import { useRef, useState } from 'react';

//Primereact components
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Toolbar } from 'primereact/toolbar';
import { ReportShowClick } from '../../../config/Validate';
import { applicationNameList, defaultPageRowOptions, defaultRowOptions, SkeletonbodyTemplate, Skeletonitems } from '../../../appconfig/Settings';
import { getAllDetailsDirect, getSpecificDetailsById, postAllData } from '../../../service/ProductService';
import { APPLICATIONREGISTERREPORT, DOWNLOADAPPLICATIONREGITERREPORT, DOWNLOADNIOSLETTER, NIOSLETTER } from '../../../config/ApiConstant';
import {
    AddNIOSLetterListColumns,
    ApplicationRegDegreeAddListColumns,
    ApplicationRegElligibleListColumns,
    ApplicationRegFirstListColumns,
    ApplicationRegGoodStandingListColumns,
    ApplicationRegNameChangeListColumns,
    ApplicationRegPenatlyListColumns,
    ApplicationRegRegistrationRenewListColumns,
    ApplicationRegTransferInListColumns,
    FreshApplicationRegFirstListColumns
} from '../../../appconfig/DatatableSetting';
import { amountCommonTemplate, amountTemplate, combinedFullNameTemplate, commonImageTemplate, commonNameTemplate, dateTemplate } from '../../../appconfig/DatatableTemplateSetting';
import { Dropdown } from 'primereact/dropdown';
import { Calendar } from 'primereact/calendar';
import moment from 'moment';
import { downloadData, exportData } from '../../../appconfig/AppHelper';
import AppBreadcrumb from '../../../components/CustomeBreadcrumb/AppBreadcrumb';
import CustomDatePicker from '../../../components/CustomDatePicker/CustomDatePicker';

export const ApplicationRegisterReport = () => {
    document.title = 'Application Register | GSPC';

    //Set Toast/ Filter Properties
    const toast = useRef<any>(null);
    const [globalFieldFilter, setGlobalFieldFilter] = useState<any>(null);
    const [globalFilter, setGlobalFilter] = useState<any>(null);

    //Loading/Page Loading
    const [pageLoad, setPageLoad] = useState<boolean>(true);
    const [errors, setErrors] = useState<any>({});
    const [selectedApplication, setSelectedApplication] = useState<any>(null);
    const [addLoader, setAddLoader] = useState<boolean>(false);
    const [applicationRegisterList, setApplicationRegisterList] = useState<any>([]);
    const [showLoading, setShowLoading] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);
    const [exportLoader, setExportLoader] = useState<boolean>(false);
    const [columnName, setColumnName] = useState<any>(FreshApplicationRegFirstListColumns);

    // Date Object
    let today = new Date();
    const [dates, setDates] = useState({
        start: new Date(today.setDate(today.getDate() - 30)),
        end: new Date()
    });

    // On Date Change

    const onDateChange = (start: any, end: any) => {
        setDates({ start, end });
    };

    // Global search
    const leftToolbarTemplate = () => {
        return (
            <>
                <div>
                    <Dropdown
                        value={selectedApplication}
                        name="application"
                        options={applicationNameList}
                        filter
                        optionLabel="name"
                        placeholder="Select Application"
                        onChange={(e) => setSelectedApplication(e.value)}
                        className={errors['application'] ? 'p-invalid mr-2' : 'mr-2'}
                    />
                    <small className="p-invalid-txt">{errors['application']}</small>
                </div>
                <CustomDatePicker startDate={dates?.start} endDate={dates?.end} onChange={onDateChange} />

                <Button label="Show" onClick={() => getApplicationRegisterData()} loading={showLoading} className="ml-2"></Button>
            </>
        );
    };

    // Right toolbar
    const rightToolbarTemplate = () => {
        return (
            <>
                <Button icon="pi pi-file-export" label="Export" onClick={() => exportCSV()} className="p-button-success" loading={exportLoader}></Button>
                <Button icon="pi pi-download" label="Download" onClick={() => downloadAllData()} className="mx-2" loading={loading}></Button>
                <Button icon="pi pi-filter-slash" label="Clear" onClick={() => clearAllFilter()} className="p-button-outlined"></Button>
            </>
        );
    };

    //downloadDAta
    const downloadAllData = async () => {
        try {
            setLoading(true);
            let startDate = moment(dates?.start).format('y-M-D') + ' 00:00:00';
            let endDate = moment(dates?.end).format('y-M-D') + ' 23:59:59';
            // Request Data
            const requestData = {
                start_date: startDate,
                end_date: endDate,
                app_name: selectedApplication?.code
            };

            const response = await downloadData(DOWNLOADAPPLICATIONREGITERREPORT, 'Application_Register_Report', requestData);
            if (response === true) {
                setLoading(false);
            } else if (response === false) {
                setLoading(false);
            }
        } catch (error: any) {
            if (error.response) {
                //Spinner False and Set Toast
                setLoading(false);
                toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Could Not Load Data' });
            }
        }
    };

    //export CSv
    const exportCSV = async () => {
        setExportLoader(true);

        let res = await exportData('Application_Register_Report');
        if (res === true) {
            setExportLoader(false);
        } else {
            setExportLoader(false);
        }
    };

    //Clear All Filter
    const clearAllFilter = () => {
        setGlobalFieldFilter(null);
        setGlobalFilter(null);
    };

    // getApplicationRegisterDataList
    const getApplicationRegisterData = async () => {
        try {
            const { errors, isError } = ReportShowClick(selectedApplication);
            setErrors(errors);
            if (!isError) {
                setPageLoad(false);
                setShowLoading(true);
                if (selectedApplication?.code === 'fresh-registration ' || selectedApplication?.code === 'fresh-registration-other-state' || selectedApplication?.code === 'transfer-in') {
                    setColumnName(FreshApplicationRegFirstListColumns);
                }
                //  else if (selectedApplication?.code === 'transfer-in') {
                //     setColumnName(ApplicationRegTransferInListColumns);
                // }
                else if (selectedApplication?.code === 'Eligibility Certificate') {
                    setColumnName(ApplicationRegElligibleListColumns);
                } else if (selectedApplication?.code === 'Registration Renew' || selectedApplication?.code === 'Re Entry') {
                    setColumnName(ApplicationRegRegistrationRenewListColumns);
                } else if (selectedApplication?.code === 'Degree Addition') {
                    setColumnName(ApplicationRegDegreeAddListColumns);
                } else if (selectedApplication?.code === 'Name Change') {
                    setColumnName(ApplicationRegNameChangeListColumns);
                } else if (selectedApplication?.code === 'Good Standing Certificate') {
                    setColumnName(ApplicationRegGoodStandingListColumns);
                } else if (selectedApplication?.code === 'Penalty u/s 36/42 of Pharmacy Act 1948') {
                    setColumnName(ApplicationRegPenatlyListColumns);
                } else if (selectedApplication?.code === 'Penalty under Jan Vishwas(Amendment of Provisions) Act, 2023') {
                    setColumnName(ApplicationRegPenatlyListColumns);
                }
                let startDate = moment(dates?.start).format('y-M-D') + ' 00:00:00';
                let endDate = moment(dates?.end).format('y-M-D') + ' 23:59:59';
                // Request Data
                const requestData = {
                    start_date: startDate,
                    end_date: endDate,
                    app_name: selectedApplication?.code
                };

                const response = await postAllData(APPLICATIONREGISTERREPORT, requestData);

                if (response) {
                    setPageLoad(true);
                    setShowLoading(false);

                    setApplicationRegisterList(response);
                }
            }
        } catch (error: any) {
            if (error.response) {
                //Spinner False and Set Toast
                setPageLoad(true);
                setShowLoading(false);

                toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Could Not Load Data' });
            }
        }
    };

    return (
        <>
            <AppBreadcrumb currentMenu={'Reports'} pageName={'Application Register'} pageTitle={'Application Register'} goToPage={true} />

            <Toast ref={toast} />
            <div className="grid crud-demo mt-2">
                <div className="col-12">
                    <div className="card">
                        <Toolbar left={leftToolbarTemplate} right={rightToolbarTemplate}></Toolbar>
                        {/* Datatable */}
                        {pageLoad ? (
                            <>
                                <DataTable
                                    value={applicationRegisterList}
                                    showGridlines
                                    stripedRows
                                    globalFilter={globalFilter}
                                    filters={globalFieldFilter}
                                    onFilter={(e) => setGlobalFieldFilter(e.filters)}
                                    className="datatable-responsive p-datatable-sm"
                                    emptyMessage="No Data Found"
                                    removableSort
                                >
                                    {columnName.map((col: any, i: any) => {
                                        if (
                                            col.field === 'PayDt' ||
                                            col.field === 'SSCYr' ||
                                            col.field === 'HSCYr' ||
                                            col.field === 'JoingYth' ||
                                            col.field === 'Passedyth' ||
                                            col.field === 'PracTrainingJoiningYth' ||
                                            col.field === 'PracTrainingPassedYth'
                                        ) {
                                            return <Column key={col.field} field={col.field} header={col.header} body={dateTemplate} style={{ minWidth: '8rem' }} />;
                                        } else if (col.field === 'ValidUpTo' || col.field === 'RegDt') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={dateTemplate} style={{ minWidth: '8rem' }} />;
                                        } else if (col.field === 'BOD') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={dateTemplate} style={{ minWidth: '8rem' }} />;
                                        } else if (col.field === 'NChangDt') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={dateTemplate} style={{ minWidth: '8rem' }} />;
                                        } else if (col.field === 'CertIDt') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={dateTemplate} style={{ minWidth: '8rem' }} />;
                                        } else if (col.field === 'NetAmt') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={amountCommonTemplate} />;
                                        } else if (col.field === 'name') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={combinedFullNameTemplate} sortable filter filterPlaceholder={'Search by ' + col.header} />;
                                        } else if (col.field === 'NameChange') {
                                            return <Column key={col.field} field={col.field} header={col.header} sortable filter filterPlaceholder={'Search by ' + col.header} />;
                                        } else if (col.field === 'ColName' || col.field === 'PAddress' || col.field === 'AAddress') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={commonNameTemplate} />;
                                        } else if (col.field === 'sr_no') {
                                            return <Column key={col.field} header={col.header} body={(_, { rowIndex }) => rowIndex + 1} style={{ minWidth: '4rem' }} />;
                                        } else {
                                            return <Column key={col.field} field={col.field} header={col.header} sortable filter filterPlaceholder={'Search by ' + col.header} />;
                                        }
                                    })}
                                </DataTable>
                            </>
                        ) : (
                            <>
                                {/* Skeleton Data table */}
                                <DataTable value={Skeletonitems}>
                                    {columnName.map((col: any, i: any) => (
                                        <Column key={col.field} field={col.field} header={col.header} body={SkeletonbodyTemplate} />
                                    ))}
                                </DataTable>
                            </>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
};
